<template>
  <div class="page">
    <div class="locations-white locations-generic">
      <section>
        <div class="locations-title">Maple Lake</div>
        <!-- <strong>Season:  May - October</strong> -->
         <br>
        <strong>Hours:</strong>
        Closed for the Season
        <br><br>
   <!-- Monday through Friday: 9:00 a.m. until last rental, 4:00 p.m.
   <br>
   Saturday and Sunday: 9:00 a.m. until last rental, 5:00 p.m. -->
        </section>
      <section>
        <strong>Boat Rentals:</strong>
        Fishing Boats, Row Boats, Kayaks, Canoes, Pedal Boats
      </section>
      <section>
        <strong>For Sale:</strong>
        Drinks, Snacks, Ice Cream, Bait, Weights and Hooks, Fishing Poles
      </section>
      <section>
        <strong>Minimum age and Weight:</strong>
        3 years, 35 lbs. (may be higher depending on water and weather
        conditions)
      </section>
      <a
        class="btn-primary btn"
        href="https://www.google.com/maps/dir/?api=1&destination=41.712144,-87.894256"
      >
        <strong>Directions</strong>
      </a>
    </div>
    <div class="locations-green locations-generic">
      <call-button tel-number="708-506-0227" />
      <br />Wolf Rd. and 95th, Willow Springs
    </div>
    <iframe
      src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2978.3208967931146!2d-87.89557508253627!3d41.71359387798078!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x880e464d355d097d%3A0x4f15bfeda8ac2084!2sMaple%20Lake%20Boating%20Center!5e0!3m2!1sen!2sus!4v1588721853115!5m2!1sen!2sus"
      width="600"
      height="450"
      frameborder="0"
      style="border:0;"
      allowfullscreen=""
      aria-hidden="false"
      tabindex="0"
    ></iframe>
  </div>
</template>

<script>
import CallButton from "../CallButton";

export default {
  name: "Maple",
  components: { CallButton },
  props: {
    msg: String,
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
a.call-button {
  color: white;
}
iframe {
  max-width: 90%;
}
.page {
  background-image: url("../../assets/maple.jpg");
  flex-direction: column;
  padding-left: 20px;
}

section {
  margin-bottom: 10px;
}
</style>
